import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, Typography, Container, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import checkpointImg from "../../../assets/images/inspection.jpg";
import backgImg from "../../../assets/images/backg.jpg";

const CheckpointHeroSection = () => {
  const { t } = useTranslation(); // Initialize translation hook
  const navigate = useNavigate();  // Initialize navigate

  return (
    <Box
      sx={{
        py: { xs: 0, md: 0 },  // Remove top/bottom padding to bring the section to the top
        width: '100%',
        backgroundImage: `url(${backgImg})`,  // Background image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          {/* Image Section (left) */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-start' },
              }}
            >
              <img
                src={checkpointImg}
                alt="Checkpoint"
                style={{
                  width: '100%',
                  maxWidth: '480px',
                  height: 'auto',
                  borderRadius: '12px',
                }}
              />
            </Box>
          </Grid>

          {/* Text Section (right) */}
          <Grid item xs={12} md={6} sx={{ mt: '5%' }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                color: '#1a1a1a',
                textAlign: { xs: 'center', md: 'left' },
                fontFamily: `'Segoe UI', Roboto, sans-serif`,
              }}
            >
              {t('how_it_works.checkpoints_title')}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                fontSize: { xs: '1rem', sm: '1.2rem' },
                color: 'text.secondary',
                mt: 2,
                textAlign: { xs: 'center', md: 'left' },
                fontFamily: `'Segoe UI', Roboto, sans-serif`,
              }}
            >
              {t('how_it_works.checkpoints_description')}
            </Typography>

            {/* Points List */}
            {[0, 1, 2].map((index) => (
              <Typography
                key={index}
                variant="body1"
                color="textSecondary"
                gutterBottom
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                {t(`how_it_works.checkpoints_points.${index}`)}
              </Typography>
            ))}

            {/* Button Section */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-start' },
                mt: 3,
              }}
            >
              <Button
                onClick={() => navigate('/signup')}
                sx={{
                  minWidth: 160,
                  padding: '12px 24px',
                  backgroundColor: '#007BFF',
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: 2,
                  whiteSpace: 'nowrap',
                  transition: 'background-color 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#0056b3',
                  },
                }}
              >
                {t('Get.Started.Checkpoint')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CheckpointHeroSection;
